import Api from '@/services/Index';

const graduateInfo = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/alumni/programs');
}

const PersonalInfo = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/alumni/personal-information');
}

const JobInfo = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/alumni/working-information');
}

const EducationInfo = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/alumni/educations');
}

const DegreeInformation = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/alumni/want-degree-information');
}

const CommunicationInfo = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/alumni/communication-approve-information');
}

const WorkHistoryInfo = async () => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/alumni/works');
}

const WorkingUpdate = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put('/alumni/working-information', formData);
}

const CommunicationInfoUpdate = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put('/alumni/communication-approve-information', formData);
}

const store = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/alumni/works/create', data);
}

const DegreeInformationUpdate = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put('/alumni/want-degree-information', formData);
}

const del = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.delete('/alumni/educations/' + id);
}

const educationCreate = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/alumni/educations/create', data);
}

const personalInfoUpdate = async (formData) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put('/alumni/personal-information', formData);
}

export default {
    graduateInfo,
    PersonalInfo,
    JobInfo,
    EducationInfo,
    DegreeInformation,
    CommunicationInfo,
    WorkHistoryInfo,
    WorkingUpdate,
    CommunicationInfoUpdate,
    store,
    DegreeInformationUpdate,
    del,
    educationCreate,
    personalInfoUpdate
}
